import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import useRewards from '../../../../../hooks/useRewards';
import { CertificatesContainer, NoCertificatesContainer, RedeemHeaderContainer, RedeemHeaderTitle } from './subcomponents';
import CertificatesList from '../CertificatesList';
import ShopMore from '../ShopMore';
import { filterActiveCertificates } from '../../../../../helpers/certificateHistoryUtils';
import isTjx from '../../../../../helpers/isTjx';
var Certificates = function () {
    var t = useTranslation().t;
    var _a = useRewards(), certificates = _a.certificates, clientId = _a.clientId, hasCertificateHistory = _a.hasCertificateHistory;
    var hasActiveCertificates = false;
    var activeCertificates = filterActiveCertificates(certificates);
    if (activeCertificates &&
        activeCertificates.certificateDetails &&
        activeCertificates.certificateDetails.length > 0) {
        hasActiveCertificates = activeCertificates.certificateDetails.length > 0;
    }
    var rewardsCertificates = isTjx(clientId)
        ? 'myRewardsCertificates'
        : 'yourRewardsCertificates';
    return (_jsx(CertificatesContainer, { children: hasCertificateHistory && hasActiveCertificates ? (_jsxs(_Fragment, { children: [clientId !== 'jcrew' && (_jsx(RedeemHeaderContainer, { children: _jsx(RedeemHeaderTitle, { children: t("fullDetailsPage.".concat(rewardsCertificates)) }) })), _jsx(CertificatesList, { activeCertificates: activeCertificates })] })) : (_jsx(NoCertificatesContainer, { children: _jsx(ShopMore, {}) })) }));
};
export default Certificates;
